<h1>AccessSoftek Fi Agent Web Application</h1>
<div>
<i>Ver. <span id="fiVersion">{{version}}</span>, Access Softek inc. </i>
<span>[current time: <span id="currentTime">{{currentTime}}</span>]</span>
<span class="okstate"> - <span id="fiStatus">[OK]</span></span>
</div>
<div>
  <ul>
    <li *ngFor="let item of statuses">{{item.Name}} lambda (v<span id="contactCenterVersion">{{item.VersionResponse.Version}}</span>) -
      <span *ngIf="item.PingResponse.Pong === 'OK'" class="okstate" id="contactCenterStatus">OK</span>
    <span *ngIf="item.PingResponse.Pong === 'NOT'" class="badstate" id="contactCenterStatus">BAD</span></li>
  </ul>
</div>
